import { render, staticRenderFns } from "./SpaceImages.vue?vue&type=template&id=5a21ccf0"
import script from "./SpaceImages.vue?vue&type=script&lang=js"
export * from "./SpaceImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports